export default "/images/18 Step3TakeAction-Consultant-To monitor progress-03.png?ae2d5446de4679552068d5bd2f4e75ef";